<div class="mainSearch bg-white pr-20 py-20 lg:px-20 lg:pt-5 lg:pb-20 rounded-4 shadow-1 mt-35">
  <form [formGroup]="searchForm" (ngSubmit)="performSearch()">
    <div class="button-grid items-center">
      <div class="searchMenu-loc px-30 lg:py-20 lg:px-0">
        <div>
          <h4 class="text-15 fw-500 ls-2 lh-16">Location</h4>
          <div class="search-input location-input">
            <i class="fas fa-map-marker-alt"></i>
            <input
              type="text"
              formControlName="location"
              placeholder="Nereye gitmek istersiniz?"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onLocationSelect($event.option.value)"
            >
              <mat-option
                *ngFor="let location of filteredLocations$ | async"
                [value]="location"
              >
                {{ location.label }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
      </div>

      <div class="searchMenu-date px-30 lg:py-20 lg:px-0">
        <button 
          type="button" 
          class="date-trigger-btn" 
          (click)="toggleCalendar(); $event.stopPropagation()"
          aria-label="Tarih seçin"
        >
          <h4 class="text-15 fw-500 ls-2 lh-16">
            Check in - Check out
          </h4>
          <div class="date-display-row">
            <div class="date-item">
              <i class="icon-calendar-2"></i>
              <span>{{ searchForm.get('checkInDate')?.value | date:'d MMM' }}</span>
            </div>
            <span class="date-separator">→</span>
            <div class="date-item">
              <i class="icon-calendar-2"></i>
              <span>{{ searchForm.get('checkOutDate')?.value | date:'d MMM' }}</span>
            </div>
          </div>
        </button>

        <app-date-range-picker
          [startDate]="searchForm.get('checkInDate')?.value"
          [endDate]="searchForm.get('checkOutDate')?.value"
          [isOpen]="isCalendarOpen"
          (dateRangeSelected)="onDateRangeSelected($event)"
          (closed)="closeCalendar()"
        ></app-date-range-picker>
      </div>

      <div class="searchMenu-guests px-30 lg:py-20 lg:px-0">
        <div (click)="toggleGuestSelector()">
          <h4 class="text-15 fw-500 ls-2 lh-16">Guest</h4>
          <div class="text-15 text-light-1 ls-2 lh-16">
            <span>{{ searchForm.get('adults')?.value }}</span> adults
            -
            <span>{{ searchForm.get('children')?.value }}</span>
            children -
            <span>{{ searchForm.get('rooms')?.value }}</span> room
          </div>
        </div>

        <div
          class="searchMenu-guests__field shadow-2"
          [class.-is-active]="isGuestSelectorOpen"
        >
          <div class="bg-white px-30 py-30 rounded-4">
            <div class="row y-gap-10 justify-between items-center">
              <div class="col-auto">
                <div class="text-15 fw-500">Adults</div>
              </div>
              <div class="col-auto">
                <div class="d-flex items-center">
                  <button
                    type="button"
                    class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                    (click)="updateGuestCount('adults', false)"
                  >
                    <i class="icon-minus text-12"></i>
                  </button>
                  <div class="flex-center size-20 ml-15 mr-15">
                    <div class="text-15">
                      {{ searchForm.get('adults')?.value }}
                    </div>
                  </div>
                  <button
                    type="button"
                    class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                    (click)="updateGuestCount('adults', true)"
                  >
                    <i class="icon-plus text-12"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="border-top-light mt-24 mb-24"></div>

            <div class="row y-gap-10 justify-between items-center">
              <div class="col-auto">
                <div class="text-15 lh-12 fw-500">Children</div>
                <div class="text-14 lh-12 text-light-1 mt-5">
                  Ages 0 - 17
                </div>
              </div>
              <div class="col-auto">
                <div class="d-flex items-center">
                  <button
                    type="button"
                    class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                    (click)="updateGuestCount('children', false)"
                  >
                    <i class="icon-minus text-12"></i>
                  </button>
                  <div class="flex-center size-20 ml-15 mr-15">
                    <div class="text-15">
                      {{ searchForm.get('children')?.value }}
                    </div>
                  </div>
                  <button
                    type="button"
                    class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                    (click)="updateGuestCount('children', true)"
                  >
                    <i class="icon-plus text-12"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="border-top-light mt-24 mb-24"></div>

            <div class="row y-gap-10 justify-between items-center">
              <div class="col-auto">
                <div class="text-15 fw-500">Rooms</div>
              </div>
              <div class="col-auto">
                <div class="d-flex items-center">
                  <button
                    type="button"
                    class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                    (click)="updateGuestCount('rooms', false)"
                  >
                    <i class="icon-minus text-12"></i>
                  </button>
                  <div class="flex-center size-20 ml-15 mr-15">
                    <div class="text-15">
                      {{ searchForm.get('rooms')?.value }}
                    </div>
                  </div>
                  <button
                    type="button"
                    class="button -outline-blue-1 text-blue-1 size-38 rounded-4"
                    (click)="updateGuestCount('rooms', true)"
                  >
                    <i class="icon-plus text-12"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="button-item">
        <button
          type="submit"
          class="mainSearch__submit button -dark-1 py-15 px-35 h-60 col-12 rounded-4 bg-blue-1 text-white"
        >
          <i class="icon-search text-20 mr-10"></i>
          Search
        </button>
      </div>
    </div>
  </form>
</div> 